export default __webpack_public_path__ + "static/media/horse_riding.41b93dd9.jpg";